const DOMICILE_TYPE = [
    { value: "House", label: "Casa" },
    { value: "CondominiumHouse", label: "Casa em condomínio" },
    { value: "Apartment", label: "Apartamento" },
    { value: "RoomingHouse", label: "Casa de cômodos" },
];

export default DOMICILE_TYPE